const env = process.env;
export default {
  BACKEND_URL: env.VUE_APP_BACKEND_URL,
  SOCKET_PORT: env.VUE_APP_SOCKET_PORT,
  SOCKET_HOST: env.VUE_APP_SOCKET_HOST,
  BASE_API: env.VUE_APP_BASE_API,
  PUSHERBEAM_INSTANCEID: env.VUE_APP_PUSHERBEAM_INSTANCEID
}